<template>
  <ProgressBar v-if="loading"  mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>

  <Sidebar />
  
  <div class="pt-1 main" >
    <router-view v-slot="{ Component, route }">
      <keep-alive v-if="route.meta.keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component v-else :is="Component" />
    </router-view>

  </div>

</template>

<script setup>


import Sidebar from '@/components/layout/Sidebar.vue'
import Footer from '@/components/layout/Footer.vue'
import ProgressBar from 'primevue/progressbar';
import { useStore } from 'vuex'
import { computed } from 'vue'
const store = useStore()

const loading = computed(() => store.state.loading);




</script>

<style>
@media screen and (min-width: 768px) {
.sidebar+.main {
  padding-left: 80px;
}
}
@media screen and (max-width: 768px) {
.sidebar+.main {
  padding-bottom: 80px;
}
}
.p-progressbar{
  background-color: #fff;
}
.p-progressbar {
  position: fixed;
  top: 0;
  width: 100%;
}
</style>